import React from "react";
import {
  GroupsIcon,
  PowerOffButton,
  PersonalSheet,
  OpenLock,
  ShieldAlert,
  DirectoyButton,
  InsertDriveFileIcon,
  WarehouseIcon,
  ApartmentIcon,
} from "@icarius-icons";
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import paths from "@icarius-router/paths";

const DEFAULT_LIST_ITEMS = [
  {
    title: "changeRole",
    icon: <BusinessCenterIcon className={"icon"} />,
    path: paths.changeRole,
  },
  {
    title: "changeSociety",
    icon: <ApartmentIcon className={"icon"} />,
    path: paths.changeSociety,
  },
  {
    title: "myGroupsTitle",
    icon: <GroupsIcon />,
    path: paths.myGroups,
  },
  {
    title: "directory",
    icon: <DirectoyButton />,
    path: paths.directory,
  },
  {
    title: "alerts",
    icon: <ShieldAlert />,
    path: paths.alerts,
  },
  {
    title: "digitalDocuments",
    icon: <InsertDriveFileIcon />,
    path: paths.digitalDocuments,
  },
  {
    title: "myDigitalWarehouse",
    icon: <WarehouseIcon />,
    path: paths.digitalWarehouse,
  },
  {
    title: "myPin",
    icon: <OpenLock />,
    path: paths.myPIN,
  },
  {
    title: "myPersonalData",
    icon: <PersonalSheet />,
    path: paths.myPersonalData
  },
  {
    title: "closeSession",
    icon: <PowerOffButton />,
    path: paths.logOut,
  },
];

export default DEFAULT_LIST_ITEMS;